import CableController from './cable_controller';

export default class extends CableController {
  static targets = ['output', 'status'];

  received(data) {
    if (this.hasStatusTarget && data.text) {
      this.statusTarget.textContent = data.text;
    }

    if (this.hasOutputTarget && data.body) {
      this.outputTarget.innerHTML = data.body;
    }
  }

  get channel() {
    return super.channel || 'PropertyContractInsuranceChannel';
  }
}
